module.exports = __webpack_public_path__ + "static/media/environment-ecovolunteering.9c318fa9.svg";